import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "accounts-widget" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "restricted-height" };
const _hoisted_4 = ["src"];
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getBrandLogoUrl } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountsWidget',
    props: {
        accounts: {},
        formatter: {},
        title: {},
        hideSeeAll: { type: Boolean },
        hideBalance: { type: Boolean },
        unique: { type: Boolean },
        max: {}
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const accounts_ = ref([]);
        function onLoad() {
            let toShow = 9999;
            if (props.max) {
                toShow = props.max;
            }
            if (props.unique) {
                const providers = [];
                props.accounts.forEach(a => {
                    if (!providers.find(p => p == a.bankDisplayName)) {
                        providers.push(a.bankDisplayName);
                        accounts_.value.push(a);
                    }
                });
            }
            else {
                accounts_.value = props.accounts;
            }
            accounts_.value = accounts_.value.slice(0, toShow);
        }
        function bankLogo(a) {
            if (a.bank?.logoUri)
                return a.bank.logoUri;
            if (a.bank?.logoPath) {
                try {
                    return require('@/assets/logos/' + a.bank.logoPath);
                }
                catch { /* fall through */ }
            }
            if (a.bank?.name)
                return getBrandLogoUrl(a.bank.name);
            return require('@/assets/round1.png');
        }
        function onLogoError(event) {
            event.target.src = require('@/assets/round1.png');
        }
        onMounted(() => { onLoad(); });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_row, {
                    class: "header-row",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/money')))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "title-col" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.title ? _ctx.title : 'My Accounts'), 1)
                            ]),
                            _: 1
                        }),
                        (!_ctx.hideSeeAll)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "arrow-col"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("img", {
                                        class: "header-arrow",
                                        src: require('@/assets/arrow-right.png'),
                                        alt: ""
                                    }, null, 8, _hoisted_2)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts_.value, (a) => {
                        return (_openBlock(), _createBlock(_component_v_row, {
                            key: a.id,
                            class: "mt-5",
                            onClick: ($event) => (_unref(router).push('/account/' + a.id))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "v-col-2 icon-col" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("img", {
                                            class: "icon",
                                            src: bankLogo(a),
                                            onError: _cache[1] || (_cache[1] = ($event) => (onLogoError($event)))
                                        }, null, 40, _hoisted_4)
                                    ]),
                                    _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { class: "account-name-col" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(a.bank.prettyName ?? a.bank.name), 1),
                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(a.accountType.prettyName), 1)
                                    ]),
                                    _: 2
                                }, 1024),
                                (!_ctx.hideBalance)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: "account-balance-col"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatter.format(Math.round(a.balance))), 1)
                                        ]),
                                        _: 2
                                    }, 1024))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 2
                        }, 1032, ["onClick"]));
                    }), 128))
                ])
            ]));
        };
    }
});
